export default __webpack_public_path__ + "static/media/logout.9445e824.svg";